/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import {
  ALLOW_COMPONENTS_TO_AFFECT_STRUCTURAL_PROPERTIES,
  BRB_TO_DIAPHRAGM_RATIO_DIR_1,
  BRB_TO_DIAPHRAGM_RATIO_DIR_2,
  DESIGN_PERIOD_DIR_1,
  DESIGN_PERIOD_DIR_2,
  LINES_OF_RESISTANCE_DIR_1,
  LINES_OF_RESISTANCE_DIR_2,
  MODE_SHAPE_METHOD,
  MODE_SHAPE_UPLOAD,
  TYPE_OF_RESISTANCE_DIR_1,
  TYPE_OF_RESISTANCE_DIR_2,
  YIELD_STORY_DRIFT_DIR_1,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import { selectHasModeShapeData, selectIsModeShapeMatch } from '#selectors/entities/models.js';
import StructuralPropertiesSection from './StructuralPropertiesSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { modelId, form } = ownProps;
  const { selectFormFieldVisibility, selectFormValues } = modelTypesByForm[form];

  const { [MODE_SHAPE_METHOD]: method, [MODE_SHAPE_UPLOAD]: upload } = selectFormValues(
    state,
    MODE_SHAPE_METHOD,
    MODE_SHAPE_UPLOAD
  );

  const isModeShapeMatch = selectIsModeShapeMatch(state, { modelId, method, upload });
  const hasModeShapeData = selectHasModeShapeData(state, { modelId });

  return {
    showAllowComponentsToAffectStructuralProperties: selectFormFieldVisibility(state)(
      ALLOW_COMPONENTS_TO_AFFECT_STRUCTURAL_PROPERTIES
    ),
    showBrbToDiaphragmRatioDir1: selectFormFieldVisibility(state)(BRB_TO_DIAPHRAGM_RATIO_DIR_1),
    showBrbToDiaphragmRatioDir2: selectFormFieldVisibility(state)(BRB_TO_DIAPHRAGM_RATIO_DIR_2),
    showLinesOfResistanceDir1: selectFormFieldVisibility(state)(LINES_OF_RESISTANCE_DIR_1),
    showLinesOfResistanceDir2: selectFormFieldVisibility(state)(LINES_OF_RESISTANCE_DIR_2),
    showTypeOfResistanceDir1: selectFormFieldVisibility(state)(TYPE_OF_RESISTANCE_DIR_1),
    showTypeOfResistanceDir2: selectFormFieldVisibility(state)(TYPE_OF_RESISTANCE_DIR_2),
    showYieldStoryDrift: selectFormFieldVisibility(state)(YIELD_STORY_DRIFT_DIR_1),
    showDesignPeriod1Dir1: selectFormFieldVisibility(state)(DESIGN_PERIOD_DIR_1),
    showDesignPeriod1Dir2: selectFormFieldVisibility(state)(DESIGN_PERIOD_DIR_2),
    showModeShapes: selectFormFieldVisibility(state)(MODE_SHAPE_METHOD),
    showModeShapeUploader: selectFormFieldVisibility(state)(MODE_SHAPE_UPLOAD),
    showModeShapeDetails: isModeShapeMatch && hasModeShapeData,
  };
};

export default connect(mapStateToProps)(StructuralPropertiesSection);
